const advancedFilterTranslations = {
    en: {
        equal: "Equal to",
        not_equal: "Not equal to",
        includes: "Includes",
        not_includes: "Not includes",
        empty: "Empty",
        greater_than: "Greater than",
        less_than: "Less than",
        greater_than_or_equal: "Greater than or equal to",
        less_than_or_equal: "Less than or equal to",
        between: "Between",
        not_between: "Not between",
        search: "Search"
    },
    nl: {
        equal: "Gelijk aan",
        not_equal: "Niet gelijk aan",
        includes: "Bevat",
        not_includes: "Bevat niet",
        empty: "Leeg",
        greater_than: "Groter dan",
        less_than: "Kleiner dan",
        greater_than_or_equal: "Groter dan of gelijk aan",
        less_than_or_equal: "Kleiner dan of gelijk aan",
        between: "Tussen",
        not_between: "Niet tussen",
        search: "Zoeken"
    }
};

export class AdvancedFilterTemplates {

    private constructor() {}

    private static getTranslatedOptions(options: string[], lang: string): string {
        const translations = advancedFilterTranslations[lang];
        return options.map(option => `<option value="${option}">${translations[option]}</option>`).join('');
    }

    static getStringOptions(lang: string): string {
        const options = ["greater_than", "less_than", "greater_than_or_equal", "less_than_or_equal", "equal", "not_equal", "between", "not_between", "includes", "not_includes", "empty"];
        return this.getTranslatedOptions(options, lang);
    }

    static getNumericOptions(lang: string): string {
        const options = ["greater_than", "less_than", "greater_than_or_equal", "less_than_or_equal", "equal", "not_equal", "between", "not_between", "empty"];
        return this.getTranslatedOptions(options, lang);
    }

    static getBooleanOptions(lang: string): string {
        const options = ["not_equal", "equal"];
        return this.getTranslatedOptions(options, lang);
    }

    static getAdvancedFilters(lang: string): string {
        const translations = advancedFilterTranslations[lang];

        return `
            <div class="bootgrid-advanced-search-container d-flex flex-column gap-2">
                <div class="w-100 filters-container d-flex flex-column gap-1"></div>
                <div class="d-flex gap-2">
                    <button class="add-filter-button btn btn-outline-success"><i class="fa fa-plus"></i></button>
                    <button type="submit" class="btn btn-outline-secondary"><i class="fa fa-search me-2"></i>${translations.search}</button>
                </div>
                <div class="error-container"></div>
            </div>
        `;
    }

    static readonly dateInput: string = `
    <div class="form-group">
        <div class='input-group date' id='datetimepicker1'>
            <input type='text' class="form-control" />
            <span class="input-group-addon">
                <span class="glyphicon glyphicon-calendar"></span>
            </span>
        </div>
    </div>
    `;
}